











import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'NumberSpan',
})
export default class extends Vue {
  @Prop() public value!: string | number;

  private isFocused = false;

  private startFocus() {
    this.isFocused = true;

    // Ждём, пока Vue обновит DOM, затем выделяем текст
    this.$nextTick(() => {
      const el = this.$refs.numberSpan as HTMLElement;
      if (!el) return;

      const selection = window.getSelection();
      const range = document.createRange();
      range.selectNodeContents(el);
      selection?.removeAllRanges();
      selection?.addRange(range);
    });
  }

  private endFocus() {
    this.isFocused = false;
  }

  private changeFormat(data: any) {
    return this.$options.filters?.numberFormat(data, 2) || this.$options.filters?.numberFormat(data, 0);
  }

  private formatFull(data: any) {
    if (data == null || data === '') return '';

    let stringValue = String(data);

    if (stringValue.toLowerCase().includes('e')) {
      stringValue = this.expandScientificNotation(stringValue);
    }

    return stringValue.replace('.', ',');
  }

  private expandScientificNotation(value: string): string {
    console.log("expandScientificNotation", value);
  const str = String(value).toLowerCase();

  if (!str.includes('e')) return str;

  const [mantissaRaw, expRaw] = str.split('e');
  const exponent = Number(expRaw);

  const negative = mantissaRaw.trim().startsWith('-');

  const pureMantissa = mantissaRaw.replace(/[+-]/g, '');

  const parts = pureMantissa.split('.');
  const intPart = parts[0] || '0';
  const fracPart = parts[1] || '';

  const digits = intPart + fracPart;

  const decimalPos = intPart.length;

  if (exponent === 0) {
    return (negative ? '-' : '') + pureMantissa;
  }

  const newPos = decimalPos + exponent;
  let result: string;

  if (newPos <= 0) {
    result = '0.' + '0'.repeat(-newPos) + digits;
  } else if (newPos >= digits.length) {
    result = digits + '0'.repeat(newPos - digits.length);
  } else {
    result = digits.slice(0, newPos) + '.' + digits.slice(newPos);
  }
  console.log("expanded result", negative ? '-' + result : result);
  return negative ? '-' + result : result;
}

}
